import * as Braze from '@braze/web-sdk';

export const changeUser = (userId: string, signature?: string) => {
  try {
    // This is resulting in an un catch error in the Braze Web SDK
    Braze.changeUser(userId, signature);
  } catch (error) {}
  try {
    Braze.openSession();
  } catch (error) {}
};

export const initializeBraze: typeof Braze.initialize = (apiKey, options) => {
  try {
    const initResult = Braze.initialize(apiKey, options);
    Braze.automaticallyShowInAppMessages();
    Braze.openSession();
    return initResult;
  } catch (error) {
    return false;
  }
};
export const openBrazeSession = Braze.openSession.bind(Braze);
export const destroyBraze = Braze.destroy.bind(Braze);
export const wipeBrazeData = Braze.wipeData.bind(Braze);
export const setLanguage = (language: string | null) => {
  Braze.getUser()?.setLanguage(language);
};
export const setFirstName = (name: string) => {
  Braze.getUser()?.setFirstName(name);
};
export const setPhoneNumber = (number: string) => {
  Braze.getUser()?.setPhoneNumber(number);
};
export const setEmail = (email: string) => {
  Braze.getUser()?.setEmail(email);
};
export const setDateOfBirth = (year: number, month: number, day: number) => {
  Braze.getUser()?.setDateOfBirth(year, month, day);
};
export const setCustomUserAttribute = (
  key: string,
  value: string | number | boolean | object | Date | null
) => {
  Braze.getUser()?.setCustomUserAttribute(key, value);
};

export const logCustomEvent = Braze.logCustomEvent.bind(Braze);
export const logPurchase = Braze.logPurchase.bind(Braze);

export const requestImmediateDataFlush = Braze.requestImmediateDataFlush.bind(Braze);
export const enableBrazeSdk = Braze.enableSDK.bind(Braze);
export const disableBrazeSdk = Braze.disableSDK.bind(Braze);
